import React from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./style.scss";
import EditIcon from "images/icon/edit_square_outline.svg";
import { History } from "models/AiResearch";
import CloseImage from "images/icon/btn_arrows_left.svg";
import OpenImage from "images/icon/btn_arrows_right.svg";

interface Props {
  history?: History[] | undefined;
  selectedId: string | null;
  onClickNewChat: () => void;
  onClickHistoryItem: (talkId: string) => void;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

// ナビゲーションコンポーネント
export const Navigation: React.FC<Props> = ({
  history,
  selectedId,
  onClickNewChat,
  onClickHistoryItem,
  isOpen,
  onOpenChange
}) => {
  return (
    <div className={cn(styles.container, !isOpen && styles.closed)}>
      {!isOpen ? (
        <>
          <button
            className={styles.openButton}
            onClick={() => onOpenChange(true)}
            tabIndex={0}
          >
            <img src={OpenImage} alt="Open" />
          </button>
          <button
            className={styles.newChatIconContainer}
            onClick={onClickNewChat}
            tabIndex={0}
          >
            <img src={EditIcon} alt="Edit Icon" />
          </button>
        </>
      ) : (
        <>
          <div
            className={styles.closeButton}
            onClick={() => onOpenChange(false)}
          >
            <img src={CloseImage} alt="Close" />
          </div>
          <div className={styles.newChatContainer}>
            <Link
              to="/ai-research"
              onClick={onClickNewChat}
              className={styles.newChat}
              tabIndex={0}
            >
              <img src={EditIcon} alt="Edit Icon" />
              新しいAIリサーチを開始
            </Link>
          </div>
          <div className={styles.historyContainer}>
            {history?.map(item => (
              <Link
                to={`?talkId=${item.talkId}`}
                onClick={() => onClickHistoryItem(item.talkId)}
                className={cn(
                  styles.historyItem,
                  item.talkId === selectedId && styles.selected
                )}
                key={item.talkId}
              >
                {item.title}
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
